export default __webpack_public_path__ + "static/media/broadcom_token.662bcd6e.png";